export const groupBy = <T, K extends keyof any>(
  list: T[],
  getKey: (item: T) => K
): { key: K; data: T[] }[] => {
  const groups: { key: K; data: T[] }[] = [];
  list.forEach((item) => {
    const key = getKey(item);
    const group = groups.find((g) => g.key === key);
    if (group) {
      group.data.push(item);
    } else {
      groups.push({ key, data: [item] });
    }
  });
  return groups;
};
